var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5041_16693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.4C0 1.07452 1.07452 0 2.4 0H10.2L18 7.8V21.6C18 22.9255 16.9255 24 15.6 24H2.4C1.07452 24 0 22.9255 0 21.6V2.4Z",
    fill: "#008A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.8H18L10.2 0V6C10.2 6.99411 11.0058 7.8 12 7.8Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5041_16693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.2499H13.5M7.2 14.3999V19.4999M4.5 16.9499H13.5M13.05 11.5499H4.95C4.70147 11.5499 4.5 11.7514 4.5 11.9999V19.1999C4.5 19.4485 4.70147 19.6499 4.95 19.6499H13.05C13.2985 19.6499 13.5 19.4485 13.5 19.1999V11.9999C13.5 11.7514 13.2985 11.5499 13.05 11.5499Z",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5041_16693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5041_16693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.8,
    fill: "white",
    transform: "translate(3.6001 10.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.7f9e9bcd004d5f89619975f3356db53f.svg";
export { ForwardRef as ReactComponent };